<template>
  <div class="relative w-full mt-5">
    <ul class="w-full">
      <li v-for="item in marks" :key="item.value" class="absolute whitespace-nowrap" :style="{ left: item.left }">
        <span class="text-small">{{ item.value }}</span>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'SliderMarks',
  props: {
    min: Number,
    max: Number,
    graticule: Number
  },
  created() {
    console.log(this.min, this.max, this.graticule)
  },
  computed: {
    marks() {
      const min = this.min
      const max = this.max
      let res = [
        {
          left: '0',
          value: min
        }
      ]
      let step = (max - min) / this.graticule
      let val = min + step
      while (val < max) {
        const finalValue = Math.round(val)
        res.push({
          left: (((finalValue - min) / (max - min)) * 100).toFixed(4) + '%',
          value: finalValue
        })
        val += step
      }
      res.push({
        left: '100%',
        value: max
      })
      return res
    }
  }
}
</script>
